import { Avatar, Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../auth/auth-service';
import { useAppSelector } from '../../store/hooks';
import { UserRole } from '../../types';
import { getRoleLabel } from '../../utils';

const UserAvatarMenu: React.FC = () => {
  const { currentUser } = useAppSelector(state => state.user);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await authService.logout();
    handleClose();
  };

  const handleMyProfile = () => {
    navigate('/my-profile');
    handleClose();
  };

  if (!currentUser) {
    return null;
  }

  const canAccessManufacturerProfile =
    (currentUser.role === UserRole.SUPERVISOR || currentUser.role === UserRole.CSR) &&
    currentUser.manufacturerId;

  const handleManufacturerProfile = () => {
    if (!canAccessManufacturerProfile) return;
    navigate('/manufacturer-profile');
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick} sx={{ p: 0, ml: 2 }}>
        <Avatar
          src={currentUser.avatar}
          alt={currentUser.firstName}
          sx={{ width: 40, height: 40 }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{
          '& .MuiPaper-root': {
            minWidth: '200px',
            maxWidth: '300px',
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Tooltip title={`${currentUser.firstName} ${currentUser.lastName}`} arrow>
            <Box
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              <Typography variant="subtitle1">
                {`${currentUser.firstName} ${currentUser.lastName}`}
              </Typography>
            </Box>
          </Tooltip>
          <Tooltip title={getRoleLabel(currentUser.role)} arrow>
            <Box
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {getRoleLabel(currentUser.role)}
              </Typography>
            </Box>
          </Tooltip>
        </Box>
        <MenuItem onClick={handleMyProfile}>My Profile</MenuItem>
        {canAccessManufacturerProfile && (
          <MenuItem onClick={handleManufacturerProfile}>Manufacturer Profile</MenuItem>
        )}
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserAvatarMenu;
